import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "home",
  class: "main-banner"
}
const _hoisted_2 = {
  key: 0,
  class: "carousel-container"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "indicators" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "banner-placeholder"
}

import { ref, onMounted, onUnmounted } from 'vue';


interface BannerSlide {
  id: string;
  url: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MainBanner',
  setup(__props) {

const endpoint = process.env.VUE_APP_HYGRAPH_URL;

const banners = ref<BannerSlide[]>([]);
const loading = ref(true);
const currentIndex = ref(0);
let timer: any = null;

// Função para otimizar a imagem via URL do Hygraph
const optimizeImage = (url: string) => {
  if (!url) return '';
  // Redimensiona para 1600px de largura e ajusta a qualidade para 80% (economiza banda)
  return url.replace('https://media.graphassets.com/', 'https://media.graphassets.com/resize=width:1400/quality=value:80/auto_image/compress/');
};

const fetchBanners = async () => {
  const query = `
    query GetBanners {
      bannerCarrossels {
        id,
        imageFirst{
            id,
            url(transformation: {
            image: { resize: { width: 1200, height: 600, fit: crop } },
            document: { output: { format: webp } }
          })
        } 
      }
    }
  `;

  try {
    const response = await fetch(endpoint!, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query })
    });

    const request = await response.json();

    if (request.data && request.data.bannerCarrossels.length > 0) {
      const rawData = request.data.bannerCarrossels[0].imageFirst;
      
      //console.log(`${JSON.stringify(rawData,null,2)}`);


      const slides: BannerSlide[] = (rawData || [])
      .map((img: any) => ({       
        id: img.id,
        url: optimizeImage(img.url)
      }))
      .filter((slide: BannerSlide) => slide.url && slide.url !== '');

//console.log(`retorno Slides ${JSON.stringify(slides,null,2)}`);

      banners.value = slides;
    }
  } catch (error) {
    console.error("Erro ao carregar banners:", error);
  } finally {
    loading.value = false;
    startTimer();
  }
};

const nextSlide = () => {
  if (banners.value.length > 0) {
    currentIndex.value = (currentIndex.value + 1) % banners.value.length;
  }
};

const prevSlide = () => {
  if (banners.value.length > 0) {
    currentIndex.value = (currentIndex.value - 1 + banners.value.length) % banners.value.length;
  }
};

const startTimer = () => {
  if (banners.value.length > 1) {
    timer = setInterval(nextSlide, 5000);
  }
};

onMounted(fetchBanners);
onUnmounted(() => { if (timer) clearInterval(timer); });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!loading.value && banners.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banners.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["slide", { active: index === currentIndex.value }])
            }, [
              _createElementVNode("img", {
                src: item.url,
                alt: 'Slide ' + (index + 1),
                loading: "lazy"
              }, null, 8, _hoisted_3)
            ], 2))
          }), 128)),
          _createElementVNode("button", {
            class: "control prev",
            onClick: prevSlide,
            "aria-label": "Slide anterior"
          }, "‹"),
          _createElementVNode("button", {
            class: "control next",
            onClick: nextSlide,
            "aria-label": "Próximo slide"
          }, "›"),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banners.value, (_, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: _normalizeClass({ active: index === currentIndex.value }),
                onClick: ($event: any) => (currentIndex.value = index)
              }, null, 10, _hoisted_5))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(loading.value ? 'Carregando banners...' : 'Nenhum banner encontrado.'), 1))
  ]))
}
}

})